import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import {
  userdocuments as documents,
  UserCheckBoxData as checkBoxData,
} from "./documents";
import { useFormik } from "formik";
import { Button } from "@mui/material";
import CustomSelection from "../../../Components/SelectionComp/CustomSelection";
import { ParagraphComp } from "../../../Components/ParagraphComp/ParagraphComp";
import { InputCompo } from "../../../Components/InputCompo/InputCompo";
import CustomInput from "../../../Components/InputCompo/CustomInput";
import { enqueueSnackbar } from "notistack";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  CreateAccountGet,
  DataUserCreateAccount,
} from "../../../Store/auth/createAccount";

const UserType = ({ setActiveStep }) => {
  const navigate = useNavigate();
  const [selectedValue, setSelectedValue] = useState("");

  const email = localStorage.getItem("dummyEmail");
  const { isLoading: fieldLoading, data: questions } = useQuery({
    queryKey: "createAccount",
    queryFn: () => CreateAccountGet(email ? email : ""),
    cacheTime: 1000 * 60 * 5,
    staleTime: 0,
  });

  const modelSchema = Yup.object().shape(
    documents.reduce((schema, field) => {
      if (field.type.toLowerCase() !== "section") {
        let validator = Yup.string(); // Default: Not required

        // Only enforce required validation if mandatory: true
        if (field.mandatory === 1) {
          validator = validator.required(`${field.question} is required`);
        }
        if (field.validation) {
          switch (field.validation.toLowerCase()) {
            case "email":
              validator = Yup.string()
                .email("Invalid email address")
                .required(`${field.question} is required`);
              break;
            case "mobile":
              validator = Yup.string()
                .matches(/^\d{10}$/, "Invalid Number. It should be 10 digit.")
                .required(`${field.question} is required`);
              break;

            default:
              break;
          }
        }

        schema[field.question_no] = validator;
      }

      return schema;
    }, {})
  );

  const formik = useFormik({
    initialValues:
      fieldLoading || !questions || !questions.documents
        ? {
            // Default values when no API data is available (localStorage fallback)
            ...documents.reduce((values, field) => {
              const savedData =
                JSON.parse(localStorage.getItem("createAccount")) || {};
              values[field.question_no] = savedData[field.question_no] || ""; // Use saved data or empty string
              return values;
            }, {}),
            ...checkBoxData.reduce((values, checkbox) => {
              const savedData =
                JSON.parse(localStorage.getItem("createAccount")) || {};

              if (savedData[checkbox.name] === 1) {
                values[checkbox.name] = true;
              } else if (savedData[checkbox.name] === 0) {
                values[checkbox.name] = false;
              } else {
                values[checkbox.name] = false;
              }

              if (checkbox.isCustomInput) {
                values[checkbox.name] = savedData[checkbox.name] || "";
              }
              return values;
            }, {}),
          }
        : {
            // Populate from API data if available
            ...questions.documents,
          },

    validationSchema: modelSchema,
    enableReinitialize: true,
    onSubmit: async (values, { setSubmitting }) => {
      console.log(values);

      try {
        // Convert the form data into a flat object
        const tempData = {
          ...documents.reduce((acc, field) => {
            acc[field.question_no] = values[field.question_no];
            return acc;
          }, {}),
          ...checkBoxData.reduce((acc, checkbox) => {
            if (checkbox.isCustomInput) {
              console.log("checkbox", checkbox);

              // For custom input checkboxes, save their input value
              acc[checkbox.name] = values[checkbox.name] || "";
            } else {
              // Save standard checkboxes as "1" or "0"
              acc[checkbox.name] = values[checkbox.name] ? "1" : "0";
            }
            return acc;
          }, {}),
        };

        // Retrieve existing data from localStorage
        const existingData =
          JSON.parse(localStorage.getItem("createAccount")) || {};

        // Merge new data with existing data
        const updatedData = {
          ...existingData,
          ...tempData,
        };

        // Save updated data to localStorage
        localStorage.setItem("createAccount", JSON.stringify(updatedData));

        const accountData = {
          full_name: "berglin",
          location: "India",
          email_id: "ber@gmail.com",
          password: "ber@123",
          mobile_number: "7889933455",
          to_verify_npo: "Draft",
          to_give_in_kind: "4400",
          to_find_npo: 1,
          for_research: 1,
          to_donate: 0,
          to_search_npo: 1,
          to_volunteer: 0,
          to_learn: 0,
          thematic_area: "Animal Protection and welfare",
          geography_state: "Andhra Pradesh",
          district: "Agra",
          beneficiary_groups: "Artists",
          fcra: "Yes",
          tags: "We started our organisation in the year 1987 and since then, served 5 number(s) of Accident Victims,Adolescents,Adults(communities/ entities) in the thematic areas of Culture and arts, Sports,Education in top state - districts of Andhra Pradesh-Anantapur,Arunachal Pradesh-Lepa Rada,Assam-Cachar and/ or pan India,  and use the key indicator(s)  Number of tickets, Number of attendees,Number of visitors to track our progress Verified",
          periodic_insights: 1,
          type_of_user: "Institutional/ Group",
          select_here: "Government",
          name_of_institution: "IHRD",
          npo_sector_professional: "",
          csr_professional: "",
          government_employee: 1,
          corporate_employee: "",
          student: "",
          advisor_to_donors: 1,
          participant_in_events_for_a_cause: "",
          other1: "",
          academia: "",
          media_person: "",
          impact_assessor: "",
          financial_auditor: "",
          consultant_to_npo: "",
          fundraiser: "",
          philanthropist: "",
          other2: "",
        };
        const compareData = Object.keys(accountData).reduce((acc, key) => {
          if (key in updatedData) {
            acc[key] = updatedData[key];
          } else {
            acc[key] = accountData[key] || ""; // Ensure missing keys are added with default empty string
          }
          return acc;
        }, {});

        const structuredData = {
          args: compareData,
        };

        await submitReg(structuredData);

        // Navigate back
      } catch (error) {
        console.error(error);
      } finally {
        setSubmitting(false);
        localStorage.removeItem("createAccount");
      }
    },
  });

  const handleCreateSuccess = () => {
    enqueueSnackbar("success!", { variant: "success" });
    localStorage.removeItem("createAccount");
    setActiveStep(3);
  };



  const saveToLocalStorage = () => {
  const tempData = {
    ...documents.reduce((acc, field) => {
      acc[field.question_no] = formik.values[field.question_no];
      return acc;
    }, {}),
    ...checkBoxData.reduce((acc, checkbox) => {
      if (checkbox.isCustomInput) {
        acc[checkbox.name] = formik.values[checkbox.name] || "";
      } else {
        acc[checkbox.name] = formik.values[checkbox.name] ? "1" : "0";
      }
      return acc;
    }, {}),
  };

  const existingData = JSON.parse(localStorage.getItem("createAccount")) || {};

  const updatedData = {
    ...existingData,
    ...tempData,
  };

  console.log(updatedData);
  

  localStorage.setItem("createAccount", JSON.stringify(updatedData));
};









  const handleCreateError = (error) => {
    if (error?.response?.data.status_code >= 500) {
      enqueueSnackbar(error?.response?.data?.status_message, {
        variant: "error",
      });
    } else {
      enqueueSnackbar(error?.response?.data?.message || error?.message, {
        variant: "error",
      });
    }
  };

  const createFarmerMutationOptions = {
    onSuccess: handleCreateSuccess,
    onError: handleCreateError,
  };

  const {
    mutate: submitReg,
    // data: regFinalData,
    // isPending: mainRegistration
  } = useMutation({
    mutationFn: DataUserCreateAccount,
    ...createFarmerMutationOptions,
  });

  const handleDropdownChange = (e) => {
    const value = e.target.value;
    formik.setFieldValue(documents[0].question_no, value);
    setSelectedValue(value);
  };

  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem("createAccount")) || {};

    // Assuming that `documents[0].question_no` is the key for dropdown value
    const savedDropdownValue = savedData["type_of_user"];
    if (savedDropdownValue) {
      formik.setFieldValue("type_of_user", savedDropdownValue);
      setSelectedValue(savedDropdownValue); // Set the local state
    }
  }, []);

  return (
    <div>
      <form
        action=""
        onSubmit={formik.handleSubmit}
        className="flex gap-3 flex-col mt-5 min-h-[60vh]"
      >
        <div className="flex flex-wrap gap-[30px] justify-between w-[100%] mt-2">
          {documents?.slice(0, 1).map((Fields) => (
            <>
              {Fields.type.toLowerCase() === "dropdown" ? (
                <div className="w-[100%]">
                  <>
                    <CustomSelection
                      required={Fields.mandatory}
                      options={Fields?.options}
                      {...formik?.getFieldProps(Fields?.question_no)}
                      onChange={handleDropdownChange}
                      name={Fields.question_no}
                      label={Fields.question}
                    />
                    {/* <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={TempFormik?.values?.[Fields.question_no] && TempFormik?.errors?.[Fields.question_no]} /> */}
                  </>
                </div>
              ) : (
                ""
              )}
            </>
          ))}
        </div>

        {selectedValue === "Individual" && (
          <>
            <div className="my-4">
              <ParagraphComp
                className="font-semibold text-lg"
                text="(Multi select for individuals)"
              />
            </div>
            <div className="w-[100%] flex gap-[24pt] flex-wrap">
              {checkBoxData?.slice(0, 16).map((item, index) => (
                <div className="w-[40%] flex gap-[24pt]" key={index}>
                  {!item.isCustomInput ? (
                    <div className="w-[100%]">
                      <label className="flex items-center space-x-2">
                        <InputCompo
                          className="bg-[#004878] text-white w-[20px] h-[20px]"
                          type="checkbox"
                          name={item.name}
                          checked={formik.values[item.name]}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        <span className="text-black">{item.label}</span>
                      </label>
                      <ParagraphComp
                        className="text-[red] text-[10px] px-[8px] mt-1"
                        text={
                          formik.touched[item.name] && formik.errors[item.name]
                        }
                      />
                    </div>
                  ) : (
                    <>
                      {item.isCustomInput && (
                        <div className="w-[100%]">
                          <label className="flex items-center space-x-2">
                            {/* <InputCompo 
                                            className='bg-[#004878] text-white w-[20px] h-[20px]' 
                                            type='checkbox'
                                            // This checkbox just toggles the input's disabled state
                                            checked={!formik.values[item.name + '_disabled']}
                                            onChange={() => {
                                            formik.setFieldValue(item.name + '_disabled', 
                                                !formik.values[item.name + '_disabled'])
                                            }}
                                        /> */}
                            <CustomInput
                              required={item.mandatory}
                              name={item.name}
                              value={formik.values[item.name] || ""}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              label={item.label}
                              disabled={formik.values[item.name + "_disabled"]}
                            />
                          </label>
                          <ParagraphComp
                            className="text-[red] text-[10px] px-[8px] mt-1"
                            text={
                              formik.touched[item.name] &&
                              formik.errors[item.name]
                            }
                          />
                        </div>
                      )}
                    </>
                  )}
                </div>
              ))}
            </div>
          </>
        )}

        {selectedValue === "Institutional/ Group" && (
          <>
            <div className="flex flex-wrap gap-[30px] justify-between w-[100%] mt-2">
              {documents?.slice(1, 2).map((Fields) => (
                <>
                  {Fields.type.toLowerCase() === "dropdown" ? (
                    <div className="w-[100%]">
                      <>
                        <CustomSelection
                          required={Fields.mandatory}
                          options={Fields?.options}
                          {...formik?.getFieldProps(Fields?.question_no)}
                          name={Fields.question_no}
                          label={Fields.question}
                          noSort={true}
                        />
                        {/* <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={TempFormik?.values?.[Fields.question_no] && TempFormik?.errors?.[Fields.question_no]} /> */}
                        <ParagraphComp
                          className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                          text={Fields.description}
                        />{" "}
                      </>
                    </div>
                  ) : (
                    ""
                  )}
                </>
              ))}
            </div>

            {formik.values.select_here === "Other" && (
              <div className="flex flex-wrap gap-[30px] justify-between w-[100%] my-4">
                {documents?.slice(2, 3).map((Fields) => (
                  <>
                    {Fields.type.toLowerCase() === "text" && (
                      <div className="w-[100%]">
                        <CustomInput
                          required={false}
                          {...formik?.getFieldProps(Fields?.question_no)}
                          name={Fields.question_no}
                          label={Fields.question}
                        />
                        <ParagraphComp
                          className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                          text={Fields.description}
                        />
                      </div>
                    )}
                  </>
                ))}
              </div>
            )}

            <div className="flex flex-wrap gap-[30px] justify-between w-[100%] my-4">
              {documents?.slice(3, 4).map((Fields) => (
                <>
                  {Fields.type.toLowerCase() === "text" ? (
                    <div className="w-[100%]">
                      <>
                        <CustomInput
                          required={
                            selectedValue === "Institutional/ Group"
                              ? true
                              : false
                          }
                          {...formik?.getFieldProps(Fields?.question_no)}
                          name={Fields.question_no}
                          label={Fields.question}
                        />
                        {/* <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={TempFormik?.values?.[Fields.question_no] && TempFormik?.errors?.[Fields.question_no]} /> */}
                        <ParagraphComp
                          className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                          text={Fields.description}
                        />{" "}
                      </>
                    </div>
                  ) : (
                    ""
                  )}
                </>
              ))}
            </div>
          </>
        )}

        {!questions ? (
          <div className="flex justify-end">
            <div className="flex gap-[20px]">
              {/* <Button onClick={() => navigate(-1)} variant='text' disableRipple sx={{color:'#ED1C24' , fontWeight:600 , textTransform:'inherit' , letterSpacing:'-.5px' , fontSize:'14px'}}>Cancel</Button> */}
              <Button
                onClick={() => {
                  saveToLocalStorage(); 
                  setActiveStep(1)
                }}
                variant="text"
                disableRipple
                sx={{
                  color: "#C00000",
                  fontWeight: 600,
                  textTransform: "inherit",
                  letterSpacing: "-.5px",
                  fontSize: "14px",
                }}
              >
                Back
              </Button>
              <Button
                type="submit"
                variant="contained"
                disabled={submitReg.isLoading} // Disable while mutation is in progress
                sx={{
                  backgroundColor: submitReg.isLoading
                    ? "#C00000A0"
                    : "#C00000", // Lighter color when disabled
                  color: "white",
                  borderRadius: "20px",
                  fontWeight: 600,
                  textTransform: "inherit",
                  letterSpacing: "-.5px",
                  fontSize: "14px",
                  "&:hover": {
                    backgroundColor: submitReg.isLoading
                      ? "#C00000A0"
                      : "#ED1C24",
                  },
                }}
              >
                Submit
              </Button>
            </div>
          </div>
        ) : (
          <></>
        )}
        {questions && (
          <div className="flex justify-end">
            <div className="flex gap-[20px]">
              <Button
                onClick={() => setActiveStep(3)}
                variant="contained"
                sx={{
                  backgroundColor: "#004878",
                  color: "white",
                  borderRadius: "20px",
                  fontWeight: 600,
                  textTransform: "inherit",
                  padding: "5px 30px",
                  letterSpacing: "-.5px",
                  fontSize: "14px",
                  "&:hover": { backgroundColor: "#004878" },
                }}
              >
                Register Offer/ Event
              </Button>
            </div>
          </div>
        )}
      </form>
    </div>
  );
};

export default UserType;
